import { type HTMLAttributes, type ReactNode } from 'react';

const PRINT_TEXT_CLASS =
  'whitespace-pre-wrap break-words py-2 text-foreground-primary body-sm [&_a]:text-inherit [&_a]:no-underline';

const PRINT_RECEIPT_CLASS =
  'whitespace-pre-wrap font-mono text-xs leading-5 text-foreground-primary [&_.pre]:whitespace-pre-wrap [&_a]:text-inherit [&_a]:no-underline';

/** Collapse padded field text into one readable line. Newlines stay. */
export function plainPrintText(text: string): string {
  return text.replace(/\t+/g, ' ').replace(/ {2,}/g, ' ').trim();
}

export function PrintText({
  children,
  ...props
}: { children: string } & HTMLAttributes<HTMLParagraphElement>) {
  const text = plainPrintText(children);
  if (!text) {
    return null;
  }
  return (
    <p className={PRINT_TEXT_CLASS} {...props}>
      {text}
    </p>
  );
}

export function PrintFieldRow({
  label,
  value,
  ...props
}: { label: string; value: string } & HTMLAttributes<HTMLDivElement>) {
  const text = plainPrintText(value);
  if (!text) {
    return null;
  }
  return (
    <div className="grid grid-cols-[minmax(7rem,11rem)_1fr] gap-x-4 py-2 body-sm" {...props}>
      <span className="text-foreground-secondary">{plainPrintText(label)}</span>
      <span className="whitespace-pre-wrap break-words text-foreground-primary">{text}</span>
    </div>
  );
}

/** A receipt keeps its original spacing. Transaction output can include HTML. */
export function PrintReceiptBlock({ children, html }: { children?: ReactNode; html?: string }) {
  if (html !== undefined) {
    return <div className={PRINT_RECEIPT_CLASS} dangerouslySetInnerHTML={{ __html: html }} />;
  }
  return <div className={PRINT_RECEIPT_CLASS}>{children}</div>;
}
